import React, { createContext, useContext } from 'react';  
import { notification } from 'antd';  

// Create a context  
const NotificationContext = createContext();  

// Create a provider component  
export const NotificationProvider = ({ children }) => {  
    const [notif, contextHolder] = notification.useNotification();  

    return (  
        <NotificationContext.Provider value={notif}>  
            {contextHolder}  
            {children}  
        </NotificationContext.Provider>  
    );  
};  

// Custom hook to use the notification context  
export const useNotificationContext = () => {  
    return useContext(NotificationContext);  
};  